import { Expose } from 'class-transformer';
import { Model } from './model';

export class BayanWayBill extends Model {
  @Expose()
  waybillId: number;
  @Expose()
  fromCity: string;
  @Expose()
  toCity: string;
  @Expose()
  isActive: boolean;
}
